import { render, staticRenderFns } from "./AlgorithmAnnotationList.vue?vue&type=template&id=73b63012&scoped=true"
import script from "./AlgorithmAnnotationList.vue?vue&type=script&lang=js"
export * from "./AlgorithmAnnotationList.vue?vue&type=script&lang=js"
import style0 from "./AlgorithmAnnotationList.vue?vue&type=style&index=0&id=73b63012&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b63012",
  null
  
)

export default component.exports